"use client"
/* */
import { useRef, useState, useEffect } from 'react';
import { useCallbackRef } from 'use-callback-ref';

const useObserveOverflow = () => {
  const observer = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const ref = useCallbackRef(null, (el) => {
    stopObserver();
    startObserver(el);
  });
  const onIntersectionChange = ([
    intersection
  ]) => {
    if (intersection) {
      setIsOverflowing(!intersection.isIntersecting);
    }
  };
  const startObserver = (el = ref.current) => {
    if (el && el instanceof Element) {
      const newObserver = new IntersectionObserver(onIntersectionChange, {
        root: el.parentElement,
        // 1 = invoke callback when the element is 100% visible within the parent element
        threshold: 1
      });
      observer.current = newObserver;
      newObserver.observe(el);
    }
  };
  const stopObserver = () => {
    observer.current?.disconnect();
  };
  useEffect(() => {
    startObserver();
    return stopObserver;
  }, [observer.current]);
  return {
    ref,
    isOverflowing
  };
};

export { useObserveOverflow };
//# sourceMappingURL=useObserveOverflow.mjs.map
